import { render, staticRenderFns } from "./AssetUploader.vue?vue&type=template&id=a1d664c4&scoped=true&"
import script from "./AssetUploader.vue?vue&type=script&lang=js&"
export * from "./AssetUploader.vue?vue&type=script&lang=js&"
import style0 from "./AssetUploader.vue?vue&type=style&index=0&id=a1d664c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d664c4",
  null
  
)

export default component.exports